import Tool, {
  type IToolActionInput,
  type IToolAvailableInput,
  type IToolEnabledInput,
  simpleToolButton,
} from './Tool';

class ToolComment extends Tool {
  static toolName = 'Comment';
  static availableWhenLocked = true;

  static action({ controller }: IToolActionInput) {
    const pointer = controller.contextMenuCanvasPoint;
    if (pointer) {
      controller.actionCreateComment({ pointer });
    } else {
      const commentableObj = controller.canvas.getActiveObject();
      if (commentableObj) {
        controller.actionCreateComment({ commentableObj });
      }
    }
  }

  static enabled({ controller, selection }: IToolEnabledInput) {
    return ToolComment.available({ controller, selection });
  }

  static available({ controller }: IToolAvailableInput) {
    const { readOnly, commentsEnabled } = controller.props;
    return !readOnly && !!commentsEnabled;
  }

  static buttonComponent() {
    return simpleToolButton(ToolComment, 'fa-regular fa-comment');
  }
}

export default ToolComment;
